export default __webpack_public_path__ + "static/media/BiofuelCircle_Vertical_Logo.07e0566b.png";